import { render, staticRenderFns } from "./AddRuleDialog.vue?vue&type=template&id=8ac12802&scoped=true"
import script from "./AddRuleDialog.vue?vue&type=script&lang=js"
export * from "./AddRuleDialog.vue?vue&type=script&lang=js"
import style0 from "./AddRuleDialog.vue?vue&type=style&index=0&id=8ac12802&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ac12802",
  null
  
)

export default component.exports